import { getRandomNumber } from "src/utils/random";

const CLINIC_PLACEHOLDERS_SMALL = [
  "/clinics/clinic-placeholder-1-small.png",
  "/clinics/clinic-placeholder-2-small.png",
  "/clinics/clinic-placeholder-3-small.png",
];

const CLINIC_PLACEHOLDERS = [
  "/clinics/clinic-placeholder-1.png",
  "/clinics/clinic-placeholder-2.png",
  "/clinics/clinic-placeholder-3.png",
];

export const getRandomClinicPlaceholder = (small: boolean) => {
  const idx = getRandomNumber(0, CLINIC_PLACEHOLDERS.length - 1);
  return small ? CLINIC_PLACEHOLDERS_SMALL[idx] : CLINIC_PLACEHOLDERS[idx];
};

export const getClinicImagePathSmall = (path: string | undefined | null) =>
  path ? path : getRandomClinicPlaceholder(true);

export const getClinicImagePath = (path: string | undefined | null) =>
  path ? path : getRandomClinicPlaceholder(false);

export const formatClinicName = (name: string | undefined | null) =>
  name &&
  name
    .replace(/-/g, " ")
    .split(" ")
    .map((el) => el.substring(0, 1).toUpperCase() + el.substring(1))
    .join(" ");
